module.exports = __webpack_public_path__ + "img/foto_achtertuin.7850ca06.jpg";